module.exports = __webpack_public_path__ + "static/media/profitloss.8342252f.png";